import {set, startOfMonth} from 'date-fns';
import {combine, createEvent, createStore} from 'effector';

import {DateRange} from '@entities/date/types';

const changed = createEvent<[Date | null, Date | null]>();
const reset = createEvent();

const today = new Date();
const from = startOfMonth(new Date());
const to = set(today, {date: today.getDate()});

const $dateRange = createStore<DateRange>({from, to})
    .on(changed, (_, [from, to]) => ({from, to}))
    .reset(reset);

export const dateState$ = combine({
    range: $dateRange,
});

export const dateModel = {
    state: dateState$,
    reset,
    changed,
};
